import { useEffect, useState } from "react";
import { fetchSsdSales } from "@/lib/ssdSalesClient";
import type { OrgSalesAggregation } from "@/lib/ssd/ssdSalesAggregation";
import { AudienceDataAggregationStrip } from "@/components/audience-data/AudienceDataAggregationStrip";
import { defaultAudienceDateFrom, defaultAudienceDateTo } from "@/components/audience-data/useAudienceData";

export function OpsSalesAggregationStrip(props: { enabled: boolean }) {
  const [aggregation, setAggregation] = useState<OrgSalesAggregation | null>(null);

  useEffect(() => {
    if (!props.enabled) return;
    let cancelled = false;
    void (async () => {
      const res = await fetchSsdSales({
        dateFrom: defaultAudienceDateFrom(),
        dateTo: defaultAudienceDateTo(),
        limit: 1,
      });
      if (cancelled) return;
      if (res.ok) setAggregation(res.data.aggregation ?? null);
    })();
    return () => {
      cancelled = true;
    };
  }, [props.enabled]);

  if (!props.enabled || !aggregation) return null;
  return <AudienceDataAggregationStrip aggregation={aggregation} />;
}
